// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.group-fields[data-v-2f38fd97] {\n  margin-bottom: -15px;\n}\n.group-fields__field[data-v-2f38fd97] {\n  gap: 24px;\n}\n.group-fields__title[data-v-2f38fd97] {\n  margin-bottom: 20px;\n  color: #000;\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 0.89;\n}\n", ""]);
// Exports
module.exports = exports;
